import React, { FC } from 'react';
import { Container, Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PostCard } from 'components/structures/general';
import { useMediaUp } from 'hooks';
import { Post } from 'services/blog/types';

interface RelatedPostsProps {
  relatedPosts: Post[];
}

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    marginTop: theme.spacing(15),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(25),
    },
  },
  cardBlock: {
    marginTop: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(8),
    },
  },
}));

const RelatedPosts: FC<RelatedPostsProps> = (props) => {
  const { relatedPosts } = props;
  const classes = useStyles();
  const isSmallUp = useMediaUp('sm');

  return (
    <Container fixed>
      <Grid container justifyContent="center">
        <Grid className={classes.title} xs={12} item>
          <Typography align="center" variant="h2">
            Related Posts
          </Typography>
        </Grid>
        <Grid className={classes.cardBlock} xs={12} item>
          <Grid container spacing={isSmallUp ? 6 : 8}>
            {relatedPosts.map((post) => (
              <Grid item sm={12} md={4} key={post.id}>
                <PostCard post={post} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RelatedPosts;
